<template>
  <component
    :is="$feature.tempMegaMenuDesktopRedesign ? LazyCmsMegaMenuL1DesktopV2 : LazyCmsMegaMenuL1DesktopLegacy"
    v-bind="{ content }"
    @click="$emit('click')"
  />
</template>

<script lang="ts" setup>
import type { MenuItem } from '#types/components/cms/mega-menu'
import { LazyCmsMegaMenuL1DesktopLegacy, LazyCmsMegaMenuL1DesktopV2 } from '#components'

export type Props = {
  content: MenuItem
}

export type Emits = {
  click: []
}

defineProps<Props>()

defineEmits<Emits>()
</script>
